import React from 'react'
import { FaFacebookF, FaTwitter, FaWhatsapp, FaInstagram } from "react-icons/fa"; import { SiLeetcode } from "react-icons/si";
// import { SiTailwindcss } from "react-icons/si";
import { SiAdobepremierepro } from "react-icons/si";
import canvaIcon from '../../assests/images/canvaicon.png';

import { SiAdobephotoshop } from "react-icons/si";
import { SiAdobeillustrator } from "react-icons/si";
import { SiAdobeaftereffects } from "react-icons/si";
import { Icon } from "@iconify/react";
// import { SiAdobeanimate } from "react-icons/si";

// import { TbBrandJavascript } from "react-icons/tb";
// import { FaJava } from "react-icons/fa";
const Media = () => {
  return (
    <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          Find me in
        </h2>
        <div className="flex gap-4">
          <span className="bannerIcon">
            <Icon icon="logos:facebook" width="30" height="30" />
          </span>

          <span className="bannerIcon">
            <a href="https://wa.me/9129019994" target="_blank" rel="noopener noreferrer">
              <Icon icon="logos:whatsapp-icon" width="30" height="30" />
            </a>
          </span>

          <span className="bannerIcon">
            <Icon icon="skill-icons:instagram" width="30" height="30" />
          </span>
        </div>
      </div>
      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          BEST SKILL ON
        </h2>
        <div className="flex gap-4">
        <span className="bannerIcon">
  <img src={canvaIcon} alt="Canva Icon" width={40} height={40} />
</span>
          <span className="bannerIcon">
            <Icon icon="skill-icons:photoshop" width="40" height="40" />
          </span>

        



          <span className="bannerIcon">
            <Icon icon="logos:adobe-premiere" width="40" height="40" />
          </span>

          <span className="bannerIcon">
            <Icon icon="skill-icons:illustrator" width="40" height="40" />
          </span>


          {/* <span className="flex gap-4">
            <SiAdobeanimate />
          </span> */}
        </div>
      </div>
    </div>
  )
}

export default Media